import { mapGetters } from 'vuex';

/**
 * Store getters map
 * @mixin
 * @displayName Mapped Getters
 */
export default {
  computed: {
    ...mapGetters({
      $accessToken: 'Auth/accessToken',
      $loadTypeName: 'LoadTypes/loadTypeName',
      $me: 'Auth/me',
      $isMrPreview: 'Auth/isMrPreview',
      $warehouseId: 'App/warehouseId',
      $warehouseOrgId: 'App/warehouseOrgId',
      $warehouseName: 'App/warehouseName',
      $warehouseOrgName: 'App/warehouseOrgName',
      $warehouseAddress: 'App/warehouseAddress',
      $warehouseInstructions: 'App/warehouseInstructions',
      $warehousePhone: 'App/warehousePhone',
      $warehouseEmail: 'App/warehouseEmail',
      $warehouseAmenities: 'App/warehouseAmenities',
      $warehousePpeRequirements: 'App/warehousePpeRequirements',
      $warehouseTimezone: 'App/warehouseTimezone',
      $warehouseSchedule: 'App/warehouseSchedule',
      $consolidatedSettings: 'App/consolidatedSettings',
      $bookingData: 'Appointments/bookingData',
      $getSettingValue: 'Settings/settingValue',
      $refNumSettings: 'Settings/refNumSettings',
      $isMilitaryTimeEnabled: 'Settings/isMilitaryTimeEnabled',
      $isRescheduleByCarrierForbidden: 'Settings/isRescheduleByCarrierForbidden',
      $warehouseAppointments: 'Appointments/warehouseAppointments',
      $orgWarehouseName: 'App/orgWarehouseName',
      $logoPath: 'App/logoPath',
      $customLogoPath: 'App/customLogoPath',
      $appointmentCreationStatus: 'App/appointmentCreationStatus'
    })
  }
};
